import { PayloadAction } from '@reduxjs/toolkit';

import { StationsState } from '../../types';

export const setSelectedStation = (
  state: StationsState,
  action: PayloadAction<StationsState['selectedStation']['data']>
) => {
  state.selectedStation.data = [...(state.selectedStation.data || []), ...(action.payload || [])];
};
